import axios from 'axios';
import config from '../config/config';

class CashRegisterApi {
  static getFiskalyClients() {
    return axios.get(`${config.server.endpoint}backend/cashRegisters/fiskalyClients`);
  }
}

export default CashRegisterApi;
